import { defineComponent as _defineComponent } from 'vue'
import {
  ProtestCategory,
  useProtestEventsStore,
} from "@/stores/protest-events";
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router/composables";
import { formatter } from "@/plugins/echarts";

import AppSelectMultipleItemsDialog from "./AppSelectMultipleItemsDialog.vue";
import LocalAnalysisDataAlert from "./LocalAnalysisDataAlert.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LocalAnalysisFormsChart',
  setup(__props) {

const route = useRoute();
const protestEventsStore = useProtestEventsStore();

let isLoading = ref<boolean>(true);
setTimeout(() => (isLoading.value = false), 0.1);

const queryCity = computed(() => {
  return protestEventsStore.cities.find(
    (city) => city.label === route.query.stadt?.toString()
  );
});
const cities = ref<ProtestCategory[]>([]);
if (queryCity.value) {
  cities.value = [queryCity.value];
}

const isStackedForms = ref<boolean>(true);
const isStackedCities = ref<boolean>(false);

const forms = ref<ProtestCategory[]>(protestEventsStore.forms);

const observationUnit = ref<string>("Anzahl der Protestevents");
const observationUnits = ref<string[]>([
  "Anzahl der Protestevents",
  "Absolute Anzahl an Teilnehmer:innen",
]);

const chartOptions = computed(() => {
  return {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: formatter,
    },
    dataZoom: [
      {
        id: "dataZoomX",
        type: "slider",
        xAxisIndex: [0],
        filterMode: "filter",
        minValueSpan: 3600 * 24 * 1000 * 365,
        backgroundColor: "rgba(53, 65, 90,0)",
        dataBackgroundColor: "rgba(53,65,90,0.3)",
        fillerColor: "rgba(169,188,208,0.1)",
        handleSize: "100%",
        textStyle: {
          color: "#333333",
        },
        showDetail: false,
      },
    ],
    grid: {
      top: "3%",
      left: "3%",
      right: "4%",
      bottom: "12%",
      containLabel: true,
    },
    xAxis: {
      type: "time",
      minInterval: 3600 * 24 * 1000,
    },
    yAxis: {
      type: "value",
      minInterval: 1,
    },
    series:
      cities.value.length > 1
        ? protestEventsStore.protestEventsGroupedByMonthAndCity(
            cities.value,
            forms.value,
            [],
            observationUnit.value,
            isStackedCities.value,
            false
          )
        : protestEventsStore.protestEventsGroupedByMonthAndForm(
            cities.value,
            forms.value,
            [],
            observationUnit.value,
            isStackedForms.value,
            false
          ),
  };
});

watch(queryCity, () => {
  if (queryCity.value) {
    cities.value = [queryCity.value];
  }
});

watch(forms, () => {
  if (forms.value.length > 1 && cities.value.length > 1) {
    if (queryCity.value) {
      cities.value = [queryCity.value];
    }
  }
});

watch(cities, () => {
  if (cities.value.length > 1 && forms.value.length > 1) {
    forms.value = forms.value.slice(0, 1);
  }
});

return { __sfc: true,route, protestEventsStore, isLoading, queryCity, cities, isStackedForms, isStackedCities, forms, observationUnit, observationUnits, chartOptions, AppSelectMultipleItemsDialog, LocalAnalysisDataAlert }
}

})